module.exports = __webpack_public_path__ + "assets/static/svg/google-icon-btn.7ef79affdc0ac648ad44100ded07061e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/assets/images/google-icon-btn.svg
 ** module id = 476
 ** module chunks = 1
 **/